import { HourMinute } from "./time"

type ReservableSlot = {
	startHour: number
	startMinute: number
	durationMinute: number
}
// cache していないため、CPU・メモリ効率は非常に悪い
// TODO: test
export class ReservableChecker {
	private mergedSlots: ReservableSlot[]
	private canReserveCanceledReservationMenusSet: boolean
	private forceEmptyWhenCannotReserveCanceledReservationMenuSet: boolean

	constructor(
		slots: ReservableSlot[],
		canReserveCanceledReservationMenusSet?: boolean,
		forceEmptyWhenCannotReserveCanceledReservationMenuSet?: boolean
	) {
		this.mergedSlots = this.mergeSlots(slots)
		this.canReserveCanceledReservationMenusSet =
			canReserveCanceledReservationMenusSet ?? true
		this.forceEmptyWhenCannotReserveCanceledReservationMenuSet =
			forceEmptyWhenCannotReserveCanceledReservationMenuSet ?? false
	}

	// TODO: claudeに書かせた変なコードだから描き直したい
	// 特に、addMinuteでoverflowしないのか気になる
	/**
	 * 予約可能な時間枠をマージする関数
	 * 重複または連続する時間枠を1つにまとめる
	 * @param slots マージ対象の時間枠配列
	 * @returns マージ済みの時間枠配列
	 */
	private mergeSlots(slots: ReservableSlot[]): ReservableSlot[] {
		// 空配列の場合は早期リターン
		if (slots.length === 0) return []

		// 開始時刻で昇順ソート
		const sortedSlots = [...slots].sort((a, b) => {
			const timeA = new HourMinute(a.startHour, a.startMinute)
			const timeB = new HourMinute(b.startHour, b.startMinute)
			return timeA.less(timeB) ? -1 : 1
		})

		const merged: ReservableSlot[] = [sortedSlots[0]]

		for (let i = 1; i < sortedSlots.length; i++) {
			const current = sortedSlots[i]
			const last = merged[merged.length - 1]

			const lastEnd = new HourMinute(
				last.startHour,
				last.startMinute
			).addMinute(last.durationMinute)

			const currentStart = new HourMinute(
				current.startHour,
				current.startMinute
			)

			// スロットが重複している場合
			if (!lastEnd.less(currentStart)) {
				const currentEnd = currentStart.addMinute(current.durationMinute)
				const lastStart = new HourMinute(last.startHour, last.startMinute)

				if (lastEnd.less(currentEnd)) {
					last.durationMinute =
						current.durationMinute +
						(currentStart.hour * 60 + currentStart.minute) -
						(lastStart.hour * 60 + lastStart.minute)
				}
			} else {
				merged.push(current)
			}
		}

		return merged
	}

	// 特定スタッフの slots, もしくは 特定の設備の slots が、start_time から duration_minute 分空いているかどうかを返す。
	// NOTE: あくまで純粋な slots に関する判定 logic であり、ずらし設定や、その他の細かい機能はここでは扱わない。
	isReservable(hourMinute: HourMinute, durationMinute: number): boolean {
		if (
			!this.canReserveCanceledReservationMenusSet &&
			this.forceEmptyWhenCannotReserveCanceledReservationMenuSet
		) {
			return false
		}

		if (hourMinute.willAddingMinuteOverflow(durationMinute)) {
			// 日付が変わる場合は予約不可
			return false
		}
		const endTime = hourMinute.addMinute(durationMinute)

		// debug用
		// console.log(
		//   "isReservable",
		//   date,
		//   startTime,
		//   hourMinute.toString(),
		//   endTime.toString()
		// );

		for (const slot of this.mergedSlots) {
			const slotStart = new HourMinute(slot.startHour, slot.startMinute)
			const slotEnd = slotStart.addMinute(slot.durationMinute)

			// debug用
			// console.log("slot", slotStart.toString(), slotEnd.toString());

			if (!hourMinute.less(slotStart) && !slotEnd.less(endTime)) {
				return true
			}
		}
		return false
	}
}
